import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class StoryblokHelperService {
  public getBlocks(items: { component: string }[], components: string[], returnEarly = false) {
    const blocks = [];
    if (!items) return blocks;
    for (const item of items) {
      if (components.includes(item.component)) {
        blocks.push(item);
        if (returnEarly) return blocks;
      }
      for (const key in item) {
        if (Array.isArray(item[key])) {
          blocks.push(...this.getBlocks(item[key], components));
          if (returnEarly && blocks.length) return blocks;
        }
      }
    }
    return blocks;
  }
}
